import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	height: 100%;
	overflow: auto;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	align-items: flex-start;
	justify-content: flex-start;
	overflow-x: hidden;
`;

export const screens = styled.div`
	width: 99.7%;
	height: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 1rem;
	align-items: center;
	justify-items: center;

	@media (max-width: 1280px) {
		grid-template-columns: 1fr 1fr;
	}

	@media (max-width: 730px) {
		grid-template-columns: 1fr;
	}
`;

export const centalizeLoad = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${color.interface.white};
	border-radius: 5px;
	padding: 1.5rem;
`;

export const screen = styled.div`
	width: 100%;
	height: 100%;
	min-height: 600px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 1.5rem;
	padding: 2rem;
	padding-bottom: 2.5rem;
	border-radius: 5px;
	background-color: ${color.interface.white};
	cursor: pointer;
	transition: all 0.3s ease-in-out;
	overflow: hidden;

	&:hover {
		/* transform: scale(1.01); */
		background-color: ${color.interface.onDragColor2};
	}

	> p {
		color: ${color.interface.blackMofiq};
		font-size: 1.8rem;
		font-weight: bold;
	}

	::-webkit-scrollbar {
		display: none; /* Oculta a barra de rolagem */
	}
`;
